import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            align: 'stretch',
            width: '100%',
            bg: 'transparent',
            borderRadius: 'base',
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        title: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        benefitStack: {
            align: 'stretch',
            gap: ['xsmall-1.base', 'xsmall-1.sm', 'xsmall-1.md', 'xsmall-1.lg'],
            p: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            width: '100%',
            borderRadius: 'large-1',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.neutral.subtle',
        },
        icon: {
            boxSize: remCalc(20),
            color: 'foreground.neutral.default',
        },
    },
    parts: ['container', 'title', 'benefitStack', 'icon'],
}
